import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=70f2820a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2820a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f2820a')) {
      api.createRecord('70f2820a', component.options)
    } else {
      api.reload('70f2820a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=70f2820a&scoped=true", function () {
      api.rerender('70f2820a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Category/edit.vue"
export default component.exports